import { NavLink, Outlet } from "react-router-dom";
import { ShoppingCart, Package, BarChart3, History, Store, TruckIcon } from "lucide-react";
import { useShop } from "@/context/ShopContext";
import { formatRupiah } from "@/lib/format";

const navItems = [
  { to: "/", label: "Kasir", icon: ShoppingCart, testid: "nav-kasir" },
  { to: "/stok", label: "Stok Barang", icon: Package, testid: "nav-stok" },
  { to: "/stok-masuk", label: "Stok Masuk", icon: TruckIcon, testid: "nav-stok-masuk" },
  { to: "/laporan", label: "Laporan", icon: BarChart3, testid: "nav-laporan" },
  { to: "/riwayat", label: "Riwayat", icon: History, testid: "nav-riwayat" },
];

export default function Layout() {
  const { summary } = useShop();

  return (
    <div className="flex h-screen bg-slate-100 overflow-hidden">
      <aside className="w-64 bg-white border-r border-slate-200 flex flex-col h-screen fixed left-0 top-0 z-40">
        <div className="px-6 py-6 border-b border-slate-100">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-lg shadow-blue-600/20">
              <Store className="w-6 h-6" strokeWidth={2.2} />
            </div>
            <div>
              <h1 className="font-heading font-bold text-lg leading-tight text-slate-900">Warung Kita</h1>
              <p className="text-xs text-slate-500">Kasir &amp; Stok</p>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {navItems.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-semibold transition-all duration-200 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-md shadow-blue-600/20"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`
              }
            >
              <Icon className="w-5 h-5" strokeWidth={2} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-slate-100">
          <div className="rounded-xl bg-slate-900 p-4 text-white">
            <p className="text-xs text-slate-400">Laba Hari Ini</p>
            <p className="font-heading font-bold text-xl mt-1" data-testid="sidebar-laba-hari-ini">
              {formatRupiah(summary?.laba_hari_ini)}
            </p>
            <p className="text-xs text-slate-400 mt-2">
              Omzet {formatRupiah(summary?.omzet_hari_ini)}
            </p>
          </div>
        </div>
      </aside>

      <main className="ml-64 flex-1 flex flex-col h-screen overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
